module.exports = "e878ee2f841384bc7f367c251d03aece.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-leg-l.png
// module id = 66
// module chunks = 0